module.exports = __webpack_public_path__ + "static/media/DSCF0123-32noiYgs.f90244cc.JPG";